import { Link } from "@remix-run/react";
import { getLocalizedLink } from "~/helpers/UrlHelper";

const sections = [
  {
    title: "Area Guides",
    image: `${process.env.PUBLIC_REMIX_APP_ASSESTS_IMAGES}/assets/blogs/area-guides.png`,
    link: "/blog/area-guides",
  },
  {
    title: "Tenant HUB",
    image: `${process.env.PUBLIC_REMIX_APP_ASSESTS_IMAGES}/assets/blogs/tenant-hub.png`,
    link: "/blog/tenants-guides",
  },
  {
    title: "Host HUB",
    image: `${process.env.PUBLIC_REMIX_APP_ASSESTS_IMAGES}/assets/blogs/host-hub.png`,
    link: "/blog/workspace-guides",
  },
  { title: "Podcast", image: `${process.env.PUBLIC_REMIX_APP_ASSESTS_IMAGES}/assets/blogs/podcast.avif`, link: "/blog/podcast" },
];

const BlogCategoriesSection = () => {
  return (
    <div className="hidden md:block py-8  text-center bg-white">
      <h2 className="text-2xl font-bold mb-8">Explore More</h2>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {sections.map(({ title, image, link }) => (
          <Link data-spinner="true" to={getLocalizedLink(link)} key={title} className="rounded border bg-white">
            <img src={image} alt={title} width={200} height={120} className="w-full h-auto rounded mb-2" />
            <h3 className="font-medium pb-4 pt2">{title}</h3>
          </Link>
        ))}
      </div>


    </div>
  )
}

export default BlogCategoriesSection